import { ProductType } from '../types/types';

export function formatDate(dateString: string | null | undefined): string {
  if (!dateString) return '—';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '—';
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

export function getProductTypeLabel(type: ProductType): string {
  const labels: Record<ProductType, string> = {
    [ProductType.Program]: 'Programa',
    [ProductType.Combo]: 'Combo',
  };
  return labels[type] || type;
}
